<template>
  <section class="studio-status btn-group btn-group-sm">
    <div class="btn btn-secondary">
      <span class="badge badge-pill badge-light mb-0 remon-mr-1 rounded-right">
        {{ room.status ? room.status : "서버 대기중" }}
      </span>
      <span class="badge badge-pill badge-light mb-0 remon-mr-1 rounded-0">
        {{ timestamp }}
      </span>
      <span class="badge badge-pill badge-light mb-0 rounded-left">
        {{ room.startedAt ? runningTime : '00:00' }}
      </span>
      <!-- <span class="badge badge-pill badge-light mb-0" v-if="startedAt"> -->
      <!--   {{ getStartedAt }} -->
      <!-- </span> -->
    </div>

    <div class="btn btn-secondary">
      <span class="badge badge-pill badge-light mb-0">
        {{ room.quizTimeLimit }}초
      </span>
    </div>

    <div class="btn btn-secondary">
      <span class="badge badge-pill badge-light mb-0 remon-mr-1 rounded-right">
        질문 : {{ room.quizIndex }} / {{ totalNumberOfQuizzes }}
      </span>
      <span class="badge badge-pill badge-light mb-0 remon-mr-1 rounded-0">
        시청자 : {{ room.totalWatchers }}
      </span>
      <span class="badge badge-pill badge-light mb-0 remon-mr-1 rounded-0">
        정답자: {{ latestNumberOfRight }}
      </span>
       <span class="badge badge-pill badge-light mb-0 remon-mr-1 rounded-0">
         상금 : {{ prizeKor }}
       </span>
       <span class="badge badge-pill badge-light mb-0 rounded-left">
         기대상금 : {{ expetedPrizeKor }}
       </span>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import l from '@/vendor/logger'
import now from '@/mixins/now'
import numToKor from '@/mixins/numToKor'

export default {
  name: 'StudioStatus',

  mixins: [now, numToKor],

  created () {
  },

  data () {
    return {
    }
  },

  computed: {
    ...mapGetters('room', [
      'formattedStartedAt',
      'prizeKor'
    ]),
    ...mapState('room', [
      'room'
    ]),
    ...mapGetters('quizzes', [
      'latestNumberOfRight',
      'totalNumberOfQuizzes'
    ]),
    ...mapState([
      'mode'
    ]),
    expetedPrizeKor () {
      if (this.room.prize && this.latestNumberOfRight > 0) {
        l.d('studio/StudioStatus/expetedPrizeKor', this.room.prize, this.latestNumberOfRight)
        return this.numToKor(
          this.room.prize / this.latestNumberOfRight
        )
      }
    }
  },

  watch: {
    room (newRoom, oldRoom) {
      if (newRoom.status === 'END') {
        this.stopTimer()
      }
    }
  }
}
</script>

<style scoped>
.remon-mr-1 {
  margin-right: 1px;
}
</style>
